import styled from 'styled-components';

const AppContainerWrap = /*#__PURE__*/styled.div.withConfig({
  displayName: "app-container-wrap__AppContainerWrap",
  componentId: "zettle__sc-1prqfyn-0"
})(["width:100%;grid-area:content;"]);

export { AppContainerWrap };
//# sourceMappingURL=app-container-wrap.js.map
